import { queryKeys } from "../queryKeys";
import { type AcatsAsset, getListAssetsForAcatsTransfer } from "../rest/acats";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetAcatsTransferAssets = ({
  accountId,
  acatsId,
  options,
}: {
  accountId: string;
  acatsId: string;
  options?: QueryOptions<AcatsAsset[]>;
}) => {
  const res = useRequest(
    queryKeys.acats.transferAssets(accountId, acatsId),
    () => getListAssetsForAcatsTransfer(accountId, acatsId),
    options,
  );
  return res;
};
